import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "redux/store";
import { DEMO_STAY_LISTINGS } from "data/listings";
import { StayDataType } from "data/types";
import { Property } from "redux/reducers/Properties/PropertiesSliceTypes";
import { getallPropertieslisting } from "../../../redux/reducers/Properties/PropertiesSlice";
import SectionGridFeaturePlacesV4 from "containers/PageHome/SectionGridFeaturesPlacesV4";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import HeaderFilter from "containers/PageHome/HeaderFilter";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionGridFeaturePlacesSkeleton from "shared/Skelton/SectionGirdSkelton";
import Pagination from "shared/Pagination/Pagination";

const MyListing: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [allData, setAllData] = useState<StayDataType[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState<string>("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isSearchLoading, setIsSearchLoading] = useState(false);

  const DEMO_DATA: StayDataType[] = DEMO_STAY_LISTINGS.filter((_, i) => i < 8);

  const getRandomIndex = () => Math.floor(Math.random() * 8);

const mergedData = (dataToBeMerged: Property[]) => {
  const newData = dataToBeMerged?.map((apiItem) => {
    const randomIndex = getRandomIndex();
    const fallback = DEMO_DATA[randomIndex];
    
    // ✅ Build address with neighborhood
    const addressParts = [
      apiItem?.neighborhood,
      apiItem?.city,
      apiItem?.state
    ].filter(Boolean);
    
    return {
      ...fallback,
      id: apiItem?.id,
      title: apiItem?.title || fallback?.title,
      place_images: apiItem?.place_images,
      address: addressParts.join(', '),  // ✅ NEW - includes neighborhood
      neighborhood: apiItem?.neighborhood,  // ✅ NEW - add neighborhood field
      availability_start: apiItem.availability_start || fallback?.date,
      availability_end: apiItem.availability_end || fallback?.date,
      price: apiItem?.price_per_month,
      href: `/listing-stay-detail/${apiItem?.slug}`,
      property_state: apiItem?.property_state || null,
      active: apiItem?.active !== undefined ? apiItem.active : false,
      property_category: apiItem?.property_category.name,
      property_type: apiItem?.property_type?.name,
      city: apiItem?.city,
      country: apiItem?.country,
      state: apiItem?.state,  // ✅ NEW - explicitly add state
      slug: apiItem?.slug,
      reviewCount: apiItem?.average?.average_review || 0,
reviewTotal: apiItem?.average?.count || 0,
      totalBedrooms: apiItem?.total_bedrooms,
    };
  });
  setAllData(newData);
};
  const heading = "My Property";
  const fetchData = async (pge: number) => {
    const data = {
      page: pge,
      query: query,
    };
    setIsLoading(true);
    try {
      const res = await dispatch(getallPropertieslisting(data)).unwrap();
      mergedData(res?.properties);
      setTotalPages(res?.meta?.total_pages || 1);
    } catch (error) {
      console.error("Error fetching properties:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.target.value);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    fetchData(newPage);
  };

  const handleSearch = async () => {
    setIsSearchLoading(true);
    try {
      await fetchData(1);
      setPage(1);
    } catch (error) {
      console.error("Error while searching:", error);
    } finally {
      setIsSearchLoading(false);
    }
  };

  useEffect(() => {
    if (query === "") {
      fetchData(1);
    }
  }, [query]);

  if (isLoading) {
    return (
      <div className="p-10">
        <SectionGridFeaturePlacesSkeleton />;
      </div>
    );
  }

  return (
    <div className="nc-PageHome relative overflow-hidden">
      <div className="container relative space-y-24 mb-24 lg:space-y-28 lg:mb-28">
        <div className="relative py-16">
          <BackgroundSection />
          <div className="nc-SectionGridFeaturePlaces relative">
            <HeaderFilter
              tabActive={"New York"}
              heading={heading}
              tabs={["New York", "Los Angeles", "Chicago"]}
              onClickTab={(tab) => console.log("Tab clicked:", tab)}
            />
            <div className="nc-MyListing">
              <div className="mb-8">
                <div className="flex items-center">
                  <input
                    type="text"
                    value={query}
                    onChange={handleSearchChange}
                    placeholder="Search By Property Name..."
                    className="p-3 w-full md:w-1/3 border rounded-lg"
                  />
                  <ButtonPrimary
                    onClick={handleSearch}
                    className={`ml-4 p-3 rounded-lg text-white ${isSearchLoading || query === ""
                      ? "bg-orange-700 cursor-not-allowed bg-opacity-70"
                      : "bg-orange-600 hover:bg-orange-700"
                      }`}
                    disabled={isSearchLoading || query === ""}
                  >
                    {isSearchLoading ? "Searching..." : "Search"}
                  </ButtonPrimary>
                </div>
              </div>
              <SectionGridFeaturePlacesV4
                stayListings={allData}
                setAllData={setAllData}
                query={query}
                setQuery={setQuery}
                fetchOldData={() => fetchData(page)}
                page={page}
                setPage={setPage}
                isLoading={isLoading}
              />
              {totalPages > 1 && (
                <div className="flex mt-16 justify-center items-center space-x-4">
                  <Pagination
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyListing;
